import "./ThankYou.module.css";
import Header from "@/reusable_sections/Header";
import ThankYouConfirmation from "./sections/ThankYouConfirmation";
import Footer from "@/reusable_sections/Footer";
export default function ThankYouPage() {
  return <div>
      <Header />
      <ThankYouConfirmation />
      <Footer />
    </div>;
}